export const FEET_IN_ONE_METER = 3.28084;
